import { setEnv } from "./env";

export const screensWithAuthToken = ["SelectCoverage", "WelcomeBack"];

export const responseAuthData = response => {
  return response?.response_data?.authentication;
};

export const registrationService = authData => {
  if (authData && authData.auth_token) {
    setEnv({
      AUTH_METHOD: "Bearer",
      AUTH_TOKEN: authData.auth_token,
      MEMBER_ID: authData.domain_id
    });

    document.cookie = `auth_token=${authData.auth_token}`;
  }
};
